import i18n from '../../../base-dictionary';
import type { KPICard } from '../process-analysis-v2.type';

export const mockKPIData: KPICard[] = [
  {
    id: 'overall_score',
    title: i18n.t('process_analysis.kpi.overall_portfolio_score'),
    icon: 'speed',
    value: 'B+',
    type: 'grade',
  },
  {
    id: 'reaction_time',
    title: i18n.t('process_analysis.kpi.average_reaction_time'),
    icon: 'timer',
    value: 0.7,
    unit: i18n.t('process_analysis.units.days'),
    change: {
      value: -14,
      label: `- 14% ${i18n.t('process_analysis.kpi.from_last_month')}`,
      isPositive: false,
    },
    type: 'single_value',
  },
  {
    id: 'cycle_time',
    title: i18n.t('process_analysis.kpi.average_cycle_time'),
    icon: 'timer',
    value: 4.1,
    unit: i18n.t('process_analysis.units.days'),
    change: {
      value: 7,
      label: `+ 7% ${i18n.t('process_analysis.kpi.from_last_month')}`,
      isPositive: true,
    },
    type: 'single_value',
  },
  {
    id: 'throughput',
    title: i18n.t('process_analysis.kpi.measurement_name'),
    icon: 'show_chart',
    value: 0.51,
    unit: i18n.t('process_analysis.units.tasks_per_hour'),
    change: {
      value: 7,
      label: `+ 7% ${i18n.t('process_analysis.kpi.from_last_week')}`,
      isPositive: true,
    },
    type: 'numerical',
  },
  {
    id: 'velocity',
    title: i18n.t('process_analysis.kpi.portfolio_velocity'),
    icon: 'screen_rotation_alt',
    value: 72,
    unit: '%',
    change: {
      value: 330,
      label: `330 ${i18n.t('process_analysis.kpi.story_points_month')}`,
      isPositive: true,
    },
    type: 'percentage',
  },
];
